import { createContext, useContext, useMemo } from 'react';
import { SCIMTokenContextValue, SCIMTokenProviderProps } from './SCIMTokenContext.types';

const SCIMTokenContext = createContext<SCIMTokenContextValue | undefined>(undefined);

export const SCIMTokenProvider = ({
  tokens,
  newlyCreatedToken,
  generateToken,
  children,
  setNewlyCreatedToken,
  isLoading,
  rotateToken,
  revokeToken,
}: SCIMTokenProviderProps) => {
  const value: SCIMTokenContextValue = useMemo(
    () => ({
      tokens,
      newlyCreatedToken,
      generateToken,
      setNewlyCreatedToken,
      isLoading,
      rotateToken,
      revokeToken,
    }),
    [tokens, newlyCreatedToken, generateToken, setNewlyCreatedToken, isLoading, rotateToken, revokeToken]
  );

  return <SCIMTokenContext.Provider value={value}>{children}</SCIMTokenContext.Provider>;
};

export const useSCIMTokenContext = () => {
  const context = useContext(SCIMTokenContext);
  if (context === undefined) {
    throw new Error('useSCIMTokenContext must be used within a SCIMTokenProvider');
  }
  return context;
};
